<template>
<div class="footerhold">
  <div class="footer">
    <div class="text-center col">
      <span class="light_text">{{footertxt}}
      </span>
    </div>
  </div>
    </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    footertxt: String
  }
}
</script>